// extracted by mini-css-extract-plugin
module.exports = {"panel":"PopoverSelect-module__panel__x5zp_","scroller":"PopoverSelect-module__scroller__1B-TI"};